<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="small" v-model="formDatas.statisticsType" clearable @change="partserch" placeholder="请选择"
                         style="width: 130px">
                        <el-option label="月" :value="1" key="1"></el-option>
                        <el-option label="年" :value="2" key="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.appiIds" size="small" collapse-tags clearable multiple
                        placeholder="请选择分摊类型" style="width: 250px" @change="partserch">
                        <el-option v-for="(item, index) in typeList || []" :label="item.appiName" :value="item.appiId"
                            :key="item.appiId"></el-option>
                    </el-select>
                    <el-date-picker type="years" v-model="formDatas.years" placeholder="选择一个或多个年" size="small"
                        value-format="yyyy" @change="partserch">
                    </el-date-picker>
                    <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="primary" size="small" style="margin-left: 20px" @click="batchExcel">导出</el-button>
                    <el-button type="danger" size="small" style="margin-left: 10px" @click="openTj">统计图</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增支付渠道</el-button> -->

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="tjId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <!-- <div class="table-pagination">
            <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
              :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
              @on-page-size-change="pageSizeChange" />
          </div> -->
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑支付渠道' : '新增支付渠道'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="支付渠道" prop="appcName">
                                <el-input v-model="form.appcName" style="width: 50%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 数据图 -->
            <el-dialog title="统计图" :visible.sync="isTjImg" width="70%" top="8vh" :before-close="handleEchartsClose">
                <div style="width: 100%;height: 500px;" @click="refClick">
                    <div ref="eCharts1" style="width: 100%;height: 100%;">

                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
    
<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import echarts from 'echarts'
import {
    getAjPurchaseOutInStatistics, addAjPurchasePayChannel, updateAjPurchasePayChannel, deleteAjPurchasePayChannel,
    getAjPurchasePublicItemListNotDt, exportAjPurchaseOutInStatistics
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            echartsData:[],
            echartsStr1: '',
            echartsStr1Value: [],
            isTjImg: false,
            typeList: [],
            key: 'tjId',
            dialog: false,
            edit: false,
            form: {
                appcName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",

                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },


                //   {
                //     field: "",
                //     key: "d",
                //     title: "操作",
                //     width: 200,
                //     align: "center",
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //       return (
                //         <span>
                //           <el-button
                //             size="mini"
                //             type="text"
                //             on-click={() => this.handleEdit(row)}
                //           >
                //             编辑
                //           </el-button>
                //           <el-button
                //             size="mini"
                //             type="text"
                //             style="color: red"
                //             on-click={() => this.handleDelete(row)}
                //           >
                //             删除
                //           </el-button>
                //         </span>
                //       );
                //     },
                //   },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                statisticsType:'',
                years: '',
                appiIds: [],
                //   currentPage: 1,
                //   pageSize: 10,
            },
            color: [
                ' #4992ff',
                ' #dd79ff',
                ' #fddd60',
                '  #ff6e76',
                ' #58d9f9',
                ' #05c091',
                '  #ff8a45',
                ' #8d48e3',
            ],
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
        this.partserch();
        getAjPurchasePublicItemListNotDt().then(res => {
            this.typeList = res.data
        })
       
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      
    },
    mounted() {
       
        const _this = this
        window.addEventListener('resize', function () {
            _this.eCharts1.resize()
        });
    },
    methods: {
        handleEchartsClose(){
            this.eCharts1.dispose();
            this.isTjImg = false;
        },
        // 图标配置项
        DrawEcharts() {
            var app = {};
            const posList = [
                'left',
                'right',
                'top',
                'bottom',
                'inside',
                'insideTop',
                'insideLeft',
                'insideRight',
                'insideBottom',
                'insideTopLeft',
                'insideTopRight',
                'insideBottomLeft',
                'insideBottomRight'
            ];
            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: posList.reduce(function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };
            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function () {
                    const labelOption = {
                        rotate: app.config.rotate,
                        align: app.config.align,
                        verticalAlign: app.config.verticalAlign,
                        position: app.config.position,
                        distance: app.config.distance
                    };
                    myChart.setOption({
                        series: [
                            {
                                label: labelOption
                            },
                            {
                                label: labelOption
                            },
                            {
                                label: labelOption
                            },
                            {
                                label: labelOption
                            }
                        ]
                    });
                }
            };
            const labelOption = {
                show: false,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {}
                }
            };
            console.log(this.$refs.eCharts1,this.echartsData);
            const Data =JSON.parse(JSON.stringify(this.echartsData));    
            const xValueLabel = Data[0].splice(1, Data[0].length);
            const xLabel = [];
            const xValue = []
            Data.forEach((item, index) => {
                if (index > 0) {
                    xLabel.push(item[0])
                    xValue.push(item.splice(1, item.length))
                }
            })
            const xValueTwo = [];
            xValueLabel.forEach((data, val) => {
                const arr = [];
                xValue.forEach((xdata, xval) => {
                   
                    arr.push(xdata[val])
                    if (xval === xValue.length - 1) {
                        // console.log(xval,arr);
                        const labelStr = {
                            name: data,
                            type: 'bar',
                            barGap: 0,
                            label: labelOption,
                            emphasis: {
                                focus: 'series'
                            },
                            data: arr
                        }

                        xValueTwo.push(labelStr)
                    }
                })
            })
            // console.log(xValueLabel, xLabel, xValue, xValueTwo);
            this.eCharts1 = this.$echarts.init(this.$refs.eCharts1)
            this.eCharts1.setOption({
                darkMode: 'auto',
                colorBy: 'series',
                color: this.color,
                // backgroundColor: '#100C2A',
                // title: {
                //     text: '· 企业拜访',
                //     left: '3%',
                //     top: "3%"
                // }, //标题位置
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                }, //提示框组件 ---数据项图形触发
                legend: {
                    // orient: 'vertical', //图标列表的布局朝向
                    // left: 'right',
                    data: xValueLabel

                },
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: { show: true },
                        dataView: { show: false, readOnly: false },
                        magicType: { show: true, type: ['bar', 'stack'] },
                        restore: { show: true },
                        saveAsImage: { show: true }
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xLabel,
                    axisTick: { show: false },
                    axisLabel: {
                        interval: 0,
                        margin: 10,
                        rotate: 30
                    },
                },
                yAxis: {
                    type: 'value'
                },
                series: xValueTwo
            })

        },
        refClick() {
            this.$nextTick(() => {
                this.DrawEcharts();
            })
        },
        openTj() {
            this.isTjImg = true;
            var newForm = JSON.parse(JSON.stringify(this.formDatas));
            newForm.years = newForm.years ? newForm.years.toString() : '';
            newForm.appiIds = newForm.appiIds ? newForm.appiIds.toString() : '';
            getAjPurchaseOutInStatistics(newForm).then((res) => {
                  this.echartsData = res.data;
                    this.refClick()
            });
          
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        // 导出
        batchExcel() {
            this.openLoading()
            var newForm = JSON.parse(JSON.stringify(this.formDatas));
            newForm.years = newForm.years ? newForm.years.toString() : '';
            newForm.appiIds = newForm.appiIds ? newForm.appiIds.toString() : '';
            var s = qs.stringify(newForm);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-purchase-out-in/exportAjPurchaseOutInStatistics',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid'),
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '行政台账统计.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjPurchasePayChannel({ appcIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjPurchasePayChannel({ appcIds: row.appcId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjPurchasePayChannel(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjPurchasePayChannel(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.appcId = row.appcId
                    console.log(jsonObj);
                    updateAjPurchasePayChannel(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjPurchaseOutInStatistics(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            // this.formDatas.currentPage = 1;
            this.columns = [
               
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
            ];
            this.tableData = [];
            console.log(this.formDatas);
            var newForm = JSON.parse(JSON.stringify(this.formDatas));
            newForm.years = newForm.years ? newForm.years.toString() : '';
            newForm.appiIds = newForm.appiIds ? newForm.appiIds.toString() : '';
            getAjPurchaseOutInStatistics(newForm).then((res) => {
                //   this.tableData = res.data;
                res.data.forEach((item, index) => {
                    if (index == 0) {
                        item.forEach((data, one) => {
                            const s = {
                                field: one + 1,
                                key: one + '',
                                // fixed: 'left',
                                title: data,
                                width: 150,
                                align: "center",
                            }
                            this.columns.push(s)
                        })
                    } else {
                        const str = {}
                        item.forEach((data, one) => {
                            str.tjId = index
                            str[one + 1] = data
                        })
                        this.tableData.push(str)
                    }

                })
                this.resetSelectedRowKeys(this.key);
            });
        },
        getList() {
            this.columns = [
               
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
            ]
            getAjPurchaseOutInStatistics(this.formDatas).then((res) => {
                res.data.forEach((item, index) => {
                    if (index == 0) {
                        item.forEach((data, one) => {
                            const s = {
                                field: one + 1,
                                key: one + '',
                                title: data,
                                width: 150,
                                align: "center",
                            }
                            this.columns.push(s)
                        })
                    } else {
                        const str = {}
                        item.forEach((data, one) => {
                            str.tjId = index
                            str[one + 1] = data
                        })
                        this.tableData.push(str)
                    }

                })
                this.resetSelectedRowKeys(this.key);
            });
        },
    },
};
</script>
    
<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
    